import { defineSagaForService } from '@repo/core'
import {
  fileDownloadConfig as awmFundsFileDownloadConfig,
  serviceConfig as awmFundsServiceConfig,
} from './data'
import { serviceConfig as operationDetailServiceConfig } from './operationDetail'

export const serviceConfig = defineSagaForService({
  ...awmFundsServiceConfig,
  ...operationDetailServiceConfig,
})

export const fileDownloadConfig = { ...awmFundsFileDownloadConfig }
